import React from 'react';
import styles from './styles.scss';
export const Title = _ref => {
  let {
    text
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.title,
    "data-hook": "share-title"
  }, text);
};
//# sourceMappingURL=title.js.map